import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Button from '../Button';

const defaultProps = {
  label: 'Cerrar',
  disabled: false,
  onClick: () => {},
};

const propTypes = {
  label: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
};

const ModalClose = ({
  label,
  disabled,
  onClick,
}) => (
  <Button
    className={classnames(
      'lg:absolute lg:top-0 lg:right-0 lg:mt-4 lg:mr-4',
      'inline-flex justify-center items-center w-10 h-10 rounded-full bg-gray-100 text-gray-500',
      'hover:bg-gray-200 hover:text-gray-900 hover:font-medium focus:outline-none',
      disabled && 'pointer-events-none opacity-50',
    )}
    onClick={onClick}
    data-dismiss="modal"
    aria-label={label}
    disabled={disabled}
  >
    <span
      className="block leading-none text-2xl font-normal flex justify-center items-center pb-1"
      aria-hidden="true"
    >
      &times;
    </span>
  </Button>
);

ModalClose.defaultProps = defaultProps;
ModalClose.propTypes = propTypes;

export default ModalClose;
